import React from 'react';
import ReactDOM from 'react-dom/client';
import '@wfp/ui/src/globals/scss/styles.scss';

import { RoutesWrappedApp } from './App';

import './index.scss';


const root = ReactDOM.createRoot(
	document.getElementById('root') as HTMLElement,
);
root.render(
	<React.StrictMode>
		<RoutesWrappedApp/>
	</React.StrictMode>,
);
